/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */

/**
 * A user's Geotab mapping may name several MyGeotab databases, held in one
 * comma-delimited field (e.g. `hunt_brothers,cooltrax_demo`) for people who
 * sign in from more than one install.
 *
 * Mirrors `api-insights/src/lib/geotabMapping.ts` — the server normalises on
 * save and matches per entry at login, so keep the two in step.
 */
export const parseGeotabDatabases = (value: string | null | undefined): string[] =>
  (value ?? '')
    .split(',')
    .map((name) => name.trim())
    .filter((name) => name.length > 0)

/**
 * Whether the field holds a usable mapping. A value of nothing but commas and
 * spaces looks filled in but normalises to empty server-side, so treat it as
 * blank here rather than letting the save come back a 400.
 */
export const hasGeotabDatabase = (value: string | null | undefined): boolean => parseGeotabDatabases(value).length > 0
